import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type UrlHashAction = {
	hash: string;
	onMatch: () => void;
	delay?: number;
	clearHash?: boolean;
	enabled?: boolean;
};

const normalizeHash = (hash: string) => hash.replace(/^#/, '').trim().toLowerCase();

export const useUrlHashAction = (actions: UrlHashAction[]) => {
	const { hash, pathname, search } = useLocation();

	useEffect(() => {
		const normalizedHash = normalizeHash(hash);
		if (!normalizedHash.length) {
			return undefined;
		}

		const matchedAction = actions.find(
			(action) => action.enabled !== false && normalizeHash(action.hash) === normalizedHash
		);

		if (!matchedAction) {
			return undefined;
		}

		const timeout = window.setTimeout(() => {
			matchedAction.onMatch();

			if (matchedAction.clearHash !== false) {
				window.history.replaceState(window.history.state, '', `${pathname}${search}`);
			}
		}, matchedAction.delay ?? 0);

		return () => {
			window.clearTimeout(timeout);
		};
	}, [actions, hash, pathname, search]);
};
